
define( 'FORCES_AND_MOTION_BASICS/../nls/da/forces-and-motion-basics-strings',{
          "none": "Ingen",
          "force": "Kraft",
          "values": "Værdier",
          "frictionTitle": "Friktion",
          "redWins": "Rød vinder",
          "frictionForce": "Friktionskraften",
          "pause": "Pause",
          "friction": "Friktion",
          "forces-and-motion-basics.name": "Kræfter og bevægelse: Basis",
          "appliedForce": "Anvendt kraft",
          "leftForce": "Venstre kraft",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Højre kraft",
          "sound": "Lyd",
          "lots": "Høj",
          "forces": "Kræfter",
          "motion": "Bevægelse",
          "tugOfWar": "Tovtrækning",
          "go": "Go!",
          "newtons.n": "Newton (N)",
          "sumOfForcesEqualsZero": "Resulterende kraft = 0",
          "blueWins": "Blå vinder!",
          "speed": "Hastighed",
          "sumOfForces": "Resulterende kraft",
          "return": "Tilbage",
          "newtons": "Newton",
          "masses": "Vægte",
          "forceReadout.pattern": "{0}N"
        } );